module.exports = __webpack_public_path__ + "eb41823a064de0a6e4d90afb164cf14b.svg";